import type { Database } from '../../types/database.generated'

export type Property = Database['public']['Tables']['properties']['Row']
export type PropertyStatus = Database['public']['Enums']['property_status']

export interface PropertyFormValues {
  name: string
  addressLine1: string
  city: string
  region: string
  postalCode: string
  countryCode: string
  status: PropertyStatus
}

export const emptyPropertyForm: PropertyFormValues = {
  name: '',
  addressLine1: '',
  city: '',
  region: '',
  postalCode: '',
  countryCode: 'US',
  status: 'draft',
}

export function propertyToFormValues(property: Property): PropertyFormValues {
  return {
    name: property.name,
    addressLine1: property.address_line_1,
    city: property.city,
    region: property.region,
    postalCode: property.postal_code,
    countryCode: property.country_code,
    status: property.status,
  }
}

export function validateProperty(values: PropertyFormValues): string | null {
  if (values.name.trim().length < 2) return 'Property name must contain at least 2 characters.'
  if (!values.addressLine1.trim()) return 'Street address is required.'
  if (!values.city.trim()) return 'City is required.'
  if (!values.region.trim()) return 'State or region is required.'
  if (!values.postalCode.trim()) return 'Postal code is required.'
  if (!/^[A-Za-z]{2}$/.test(values.countryCode.trim())) return 'Country code must contain 2 letters.'
  return null
}
